module.exports = __webpack_public_path__ + "ws.svg?c4eb05965d7ed2e7d561e80e18dc1b68";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ws.svg
// module id = 1696
// module chunks = 0